/**
 * Updates state after requestGroupUAUpdate returns
 * @param {string} res The returned string from requestGroupUAUpdate
 * @param {object} groupUAs The object containing all groupUAs the user has access to
 * @param {string} selectedGroupUA The id of the selectedGroupUA currently in view
 * @param {number} year The active year
 * @param {string} assessmentId The set id of the assessment currently in view
 * @param {object} actions fetchingGroupUAsSuccess and either refreshingSuccess or setState
 * @param {boolean} selector_call true if called from the AssessSelectorBar
 */
export default function processGroupUAUpdate(
  res,
  groupUAs,
  selectedGroupUA,
  m_gua,
  year,
  assessmentId,
  actions,
  selector_call
) {
  let newGroupUAs = {}

  if (res) {
    const checkErrors = JSON.parse(res)
    if (checkErrors && checkErrors.error)
      return actions.refreshingError(checkErrors)
    // if we got back a GUA, then replace the active GUA with the new one
    let GUAs = JSON.parse(res)

    GUAs.forEach(gua => {
      newGroupUAs = {
        ...newGroupUAs,
        [`${gua.id}`]: gua
      }
    })
    groupUAs = {
      ...groupUAs,
      ...newGroupUAs
    }
    actions.fetchingGroupUAsSuccess(groupUAs)
  } else {
    const guaKey = m_gua ? `${m_gua}_${selectedGroupUA}` : selectedGroupUA
    // otherwise make sure the new GUA displayed is null
    if (groupUAs[guaKey]) {
      let nullGUA = { ...groupUAs[guaKey] }
      if (nullGUA[year] && nullGUA[year][assessmentId]) {
        nullGUA[year][assessmentId] = null
      }
      newGroupUAs = {
        ...groupUAs,
        [guaKey]: nullGUA
      }
    }
    actions.fetchingGroupUAsSuccess(newGroupUAs)
  }

  if (selector_call) {
    actions.refreshingSuccess()
  } else {
    actions.updateState({ updatingGUA: false })
  }
}
